<template>
  <div>
    <div class="con-box">
      <img
        class="con-img"
        src="@/assets/image/bg4.png"
        alt=""
      >
      <div class="nr-box">
        <div class="bottom-box" style="margin-bottom: 30px;">
          <div
            v-for="(item, index) in topItems"
            :key="item.id"
            class="bot-item"
            :class="getItemClass(index)"
          >
            <div class="item-title">{{ item.title }}</div>
            <div class="item-desc">{{ item.description }}</div>
            <div class="item-btn" @click="handleItemClick(item)">
              <div class="item-btn-text" style="color: #F39800;">立即查看</div>
              <img
                class="item-btn-img"
                :src="getButtonIcon(index)"
                alt=""
              >
            </div>
          </div>
        </div>

        <div class="bottom-box">
          <div
            v-for="item in bottomItems"
            :key="item.id"
            class="bot-item"
          >
            <div class="item-title">{{ item.title }}</div>
            <div class="item-desc">{{ item.description }}</div>
            <div class="item-btn" @click="handleItemClick(item)">
              <div class="item-btn-text">立即查看</div>
              <img
                class="item-btn-img"
                src="@/assets/image/you1.png"
                alt=""
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHomeNav } from '@/api/user'

export default {
  name: 'Dashboard',
  data() {
    return {
      homeNavItems: [] // 存储从API获取的导航数据
    }
  },
  computed: {
    // 顶部两个项目（API返回的前两条数据）
    topItems() {
      return this.homeNavItems.slice(0, 2)
    },
    // 底部项目（API返回的剩余数据）
    bottomItems() {
      return this.homeNavItems.slice(2)
    }
  },
  created() {
    this.fetchHomeNav()
  },
  methods: {
    // 获取首页导航数据
    async fetchHomeNav() {
      try {
        const response = await getHomeNav()
        if (response && response.data) {
          this.homeNavItems = response.data
        }
      } catch (error) {
        console.error('获取首页导航数据失败:', error)
        // 如果API调用失败，使用默认数据
        this.homeNavItems = [
          {
            id: 1,
            title: '材价信息',
            description: '括各种建筑材料的市场价格，如钢材、水泥、木材、砂石料、砖瓦……'
          },
          {
            id: 2,
            title: '造价案例',
            description: '详细介绍工程项目的基本情况，包括工程类型（如住宅、商业、工业厂房等）'
          },
          {
            id: 3,
            title: '造价师服务',
            description: '造价师服务是以工程造价专业知识和技能为核心，为建设项目全生命周期提……'
          },
          {
            id: 4,
            title: '造价问答',
            description: '造价问答是围绕建设工程领域中工程造价相关知识、实践问题展开的信息交……'
          },
          {
            id: 5,
            title: '智能造价',
            description: '智能造价是依托人工智能、大数据、云计算、BIM等新兴技术，对传统工……'
          }
        ]
      }
    },
    // 获取项目样式类名
    getItemClass(index) {
      return index === 0 ? 'top-list1' : 'top-list2'
    },
    // 获取按钮图标
    getButtonIcon(index) {
      return index === 0 ? require('@/assets/image/you2.png') : require('@/assets/image/you2.png')
    },
    // 处理项目点击事件
    handleItemClick(item) {
      // 根据不同的项目跳转到不同的页面
      const routeMap = {
        1: '/material', // 材价信息
        2: '/costcases', // 造价案例
        3: '/service', // 造价师服务
        4: '/costqa', // 造价问答
        5: '/intelligent' // 智能造价
      }
      const route = routeMap[item.id]
      if (route) {
        this.$router.push(route)
      } else {
        console.warn('未找到对应的路由:', item.title)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.con-box {
  position: relative;

  .con-img {
    width: 100%;
    height: 1046px;
    display: flex;
  }

  .nr-box {
    width: 80%;
    max-width: 1200px;
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translateX(-50%);

    .bottom-box {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .top-list1 {
        width: 47% !important;
        height: 240px !important;
        background-image: url('../../assets/image/bg5.png') !important;
        background-size: 100% 100% !important;
        background-repeat: no-repeat !important;
        background-position: center !important;
        background-color: transparent !important;
        padding: 28px 24px !important;

        .item-title {
          font-size: 24px !important;
        }

        .item-desc {
          font-size: 15px !important;
          margin: 12px 0 20px 0 !important;
        }

        .item-btn {
          cursor: pointer !important;
          transition: opacity 0.3s ease !important;

          &:hover {
            opacity: 0.8 !important;
          }
        }

        .item-btn-text {
          font-size: 15px !important;
        }
      }
      .top-list2 {
        width: 47% !important;
        height: 240px !important;
        background-image: url('../../assets/image/bg6.png') !important;
        background-size: 100% 100% !important;
        background-repeat: no-repeat !important;
        background-position: center !important;
        background-color: transparent !important;
        padding: 28px 24px !important;

        .item-title {
          font-size: 24px !important;
        }

        .item-desc {
          font-size: 15px !important;
          margin: 12px 0 20px 0 !important;
        }

        .item-btn {
          cursor: pointer !important;
          transition: opacity 0.3s ease !important;

          &:hover {
            opacity: 0.8 !important;
          }
        }

        .item-btn-text {
          font-size: 15px !important;
        }
      }
      .bot-item {
        width: 30%;
        height: 200px;
        background: #ffffff;
        border-radius: 16px;
        // border: 2px solid #ffffff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 24px 20px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

        .item-title {
          color: #0f6fe2;
          font-size: 22px;
          font-weight: 600;
          margin-bottom: 12px;
          line-height: 1.3;
        }

        .item-desc {
          color: #666666;
          font-size: 14px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          line-clamp: 3;
          overflow: hidden;
          text-overflow: ellipsis;
          margin: 0 0 16px 0;
          line-height: 1.6;
        }

        .item-btn {
          display: flex;
          align-items: center;
          margin-top: auto;
          cursor: pointer;
          transition: opacity 0.3s ease;

          &:hover {
            opacity: 0.8;
          }

          .item-btn-text {
            color: #0F6FE2;
            font-size: 14px;
            margin-right: 8px;
            font-weight: 500;
          }

          .item-btn-img {
            width: 18px;
            // height: 18px;
          }
        }
      }
    }
  }
}
</style>
